import constants from './CommonConstants';
import { PIPELINE_TYPE } from './PipelineConstatnts';

export const ARCHIVED_FILTER_OBJ = {
  presetDisplayName: 'Hide Archived',
  isPreset: true,
  attribute: {
    name: 'system:entityArchived',
    dataType: 'boolean',
    displayName: 'Hide Archived',
  },
  filter: 'equals',
  value: ['false'],
  isHideCustomFilter: false,
  presetId: 1,
};
export const CHURNED_FILTER_OBJ = {
  presetDisplayName: 'Hide Churned',
  isPreset: true,
  attribute: {
    name: 'system:churned',
    dataType: 'boolean',
    displayName: 'Hide Churned',
  },
  filter: 'equals',
  value: ['false'],
  isHideCustomFilter: false,
  presetId: 2,
};

const FILTERS_LIST = {
  HIDE_ARCHIVED: {
    displayName: 'Hide Archived',
    name: 'system:entityArchived',
    filter: 'equals',
    value: ['false'],
  },
  HIDE_CHURNED: {
    displayName: 'Hide Churned',
    name: 'system:churned',
    filter: 'equals',
    value: ['false'],
  },
};

export const PIPELINE_FILTER_DEFAULT_MAPPING = {
  [PIPELINE_TYPE.OPPORTUNITY.id]: [
    {
      presetId: 3,
      isPresetFilter: true,
    },
    {
      presetId: 4,
      isPresetFilter: true,
    },
  ],
  [PIPELINE_TYPE.RISK.id]: [
    {
      presetId: 5,
      isPresetFilter: true,
    },
    {
      presetId: 6,
      isPresetFilter: true,
    },
  ],
};

export const LIST_LEVEL_FILTER_DEFAULT_MAPPING = {
  [constants.ORGANIZATION_LEVEL]: [
    {
      presetId: 1,
      isPresetFilter: true,
    },
    {
      presetId: 2,
      isPresetFilter: true,
    },
  ],
  [constants.ACCOUNT_LEVEL]: [
    {
      presetId: 1,
      isPresetFilter: true,
    },
    {
      presetId: 2,
      isPresetFilter: true,
    },
  ],
  [constants.CONTACT_LEVEL]: [
    {
      presetId: 1,
      isPresetFilter: true,
    },
  ],
  [constants.PIPELINE_LEVEL]: [
    // {
    //   presetId: 1,
    //   isPresetFilter: true,
    // },
    {
      presetId: 2,
      isPresetFilter: true,
    },
  ],
  [constants.CUSTOM_OBJECT_LEVEL]: [
    {
      presetId: 1,
      isPresetFilter: true,
    },
  ],
};

export const BOARD_LEVEL_FILTER_PRESET_MAPPING = {
  [constants.ORGANIZATION_LEVEL]: [
    {
      ...FILTERS_LIST.HIDE_ARCHIVED,
      presetId: 1,
      isHideCustomFilter: false,
    },
    {
      ...FILTERS_LIST.HIDE_CHURNED,
      presetId: 2,
      isHideCustomFilter: false,
    },
  ],
  [constants.ACCOUNT_LEVEL]: [
    {
      ...FILTERS_LIST.HIDE_ARCHIVED,
      presetId: 1,
      isHideCustomFilter: false,
    },
    {
      ...FILTERS_LIST.HIDE_CHURNED,
      presetId: 2,
      isHideCustomFilter: false,
    },
  ],
  [constants.PIPELINE_LEVEL]: [
    {
      ...FILTERS_LIST.HIDE_ARCHIVED,
      presetId: 1,
      isHideCustomFilter: false,
    },
  ],
};

export const BOARD_LEVEL_FILTER_DEFAULT_MAPPING = {
  [constants.ORGANIZATION_LEVEL]: [
    {
      presetId: 1,
      isPresetFilter: true,
    },
    {
      presetId: 2,
      isPresetFilter: true,
    },
  ],
  [constants.ACCOUNT_LEVEL]: [
    {
      presetId: 1,
      isPresetFilter: true,
    },
    {
      presetId: 2,
      isPresetFilter: true,
    },
  ],
  [constants.PIPELINE_LEVEL]: [
    {
      presetId: 1,
      isPresetFilter: true,
    },
  ],
};

export const USER_DISABLED_FILTER_MESSAGE =
  'This filter is disabled for this view';

export const FILTER_NAME = {
  IS_SET_TO: 'isSetTo',
};

export const DEFAULT_ACTIVE_ENTITY_COUNT_FILTER = {
  page: 1,
  pageSize: 1,
  displayCurrency: 2,
  filter: 'boolean::system:entityArchived=equals=(false)',
};
